import { registerSW } from "virtual:pwa-register";
import { useFeedback } from "@/stores/feedback";
import { captureInstallPrompt } from "./install";

export function registerPwa() {
  captureInstallPrompt();
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  const update = registerSW({
    onNeedRefresh() {
      useFeedback.getState().show({
        key: "app-update",
        kind: "info",
        message: "An update is ready.",
        actionLabel: "Reload",
        action: () => update(true),
        durationMs: 60_000,
      });
    },
  });
}
